import { Typography, UserFlag, Box, Badge, UserAvatar, CircularProgress } from 'src/components';
import { useAuth } from 'src/utils';

export default function UserListCard({ user, onClick }) {
    const { user: currentUser } = useAuth();

    if (!user) return null;

    const isCurrentUser = currentUser?.id === user?.id;

    const bioPreview = user?.bio?.slice(0, 77) + (user?.bio?.length > 77 ? '...' : '');

    return (
        <Box sx={{
                border: '2px solid', 
                borderColor: isCurrentUser ? 'rgba(25, 118, 210, 0.4)' : '#D3D3D3',
                borderRadius: 2,
                width: '100%',
                mb: 1,
                p: 1,
                cursor: 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: isCurrentUser ? 1 : 0,
            }}
            onClick={() => onClick(user)}>

            {user?.profileImageUrl ? (
                <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                        user?.countryIsoAlpha2 && <UserFlag countryCode={user.countryIsoAlpha2} />
                    }>
                    <UserAvatar user={user} size={48}/>
                </Badge>
            ) : (
                <UserAvatar user={user} size={48}/>
            )}

            <Box sx={{width: '100%', ml: 1}}>
                {!user?.name ? (
                    <CircularProgress size={20} />
                ) : (<>
                    <Typography variant="h6">{user.name}</Typography>
                    <Typography variant="body2">{user.bio ? bioPreview : ''}</Typography>
                </>)}
            </Box>
        </Box>
    );
}
